var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "survey-evaluation"
  }, [_c('span', {
    staticClass: "mt-5"
  }, [_vm._v(_vm._s(_vm.options[0] && _vm.options[0].title))]), _c('a-rate', {
    staticClass: "ml-20 mr-20",
    attrs: {
      "count": _vm.options.length
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.rate,
      callback: function ($$v) {
        _vm.rate = $$v;
      },
      expression: "rate"
    }
  }), _c('span', {
    staticClass: "mt-5"
  }, [_vm._v(_vm._s(_vm.options[_vm.options.length - 1] && _vm.options[_vm.options.length - 1].title))])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };